import type { Degree, Measure } from "../types/units/Units"

import { ToRadians } from "./ToRadians"

/**
 * Rotates a point around a center point by the specified angle
 * @param cx - X coordinate of the center point
 * @param cy - Y coordinate of the center point
 * @param x - X coordinate of the point to rotate
 * @param y - Y coordinate of the point to rotate
 * @param angle - Rotation angle in degrees
 * @returns The coordinates of the rotated point
 */
export const Rotate = <T extends Measure>(
  cx: T,
  cy: T,
  x: T,
  y: T,
  angle: Degree
): { x: T; y: T } => {
  if (angle) {
    const rad = ToRadians(angle as Degree)
    const cos = Math.cos(rad)
    const sin = Math.sin(rad)
    return {
      x: (cos * (x - cx) + sin * (y - cy) + cx) as T,
      y: (cos * (y - cy) - sin * (x - cx) + cy) as T,
    }
  }
  return { x, y }
}
